export enum AttendanceType{
    in = 1,
    out = 2

}